export function siteFilterMaterial() {
  return {
    restrict: 'E',
    template: require('./site-filter-material.directive.html'),
    scope: {
      sitesFromParent: '=sites', // Array of (at least one) sites to be offered; they must have the following attributes: id, name and type_name
      selectedId: '=', // Element currently selected. The directive will use the initial value, unless it is not found in the site list
      addAllSitesItem: '=', // Add the special "All sites" item (with id=0) at the beginning of the list,
      withoutUnderline: '<?', // Prevent the material form underline
    },
    controller: SiteFilterController
  };
}


SiteFilterController.$inject = ['$scope', '$translate', '$q'];
function SiteFilterController($scope, $translate, $q) {

  $scope.siteClicked = siteClicked; // for the uib directive

  let _revertingToOldSite = false;

  _init();

  function _init() {
    $scope.sites = angular.copy($scope.sitesFromParent); // clone the array before addind an item to it
    if ($scope.addAllSitesItem) {
      $scope.sites.unshift({
        id: 0,
        name: $translate.instant('parameters/shared/all_sites'),
        type_name: null, // no icon,
        sortKey: '000' // appear first in the list
      });
    }
    // Let's sort the array (as opposed to use the 'sort' pipe in the directive markup)
    // so that the default selected value is the first in the displayed list
    $scope.sites.sort((a, b) => {
      if (a.sortKey < b.sortKey) {
        return -1;
      }
      if (a.sortKey > b.sortKey) {
        return 1;
      }
      return 0;
    });

    // If the selectedSite passed to us in the directive paramter is found in the sites list, let's use it,
    // otherwise default to the list's first item
    let initialSite = $scope.sites[0];
    $scope.sites.filter(s => s.id === $scope.selectedId) // the filter will return 0 or 1 item
      .forEach(s => initialSite = s);
    $scope.selected = initialSite;
    watchSelectedSite();
  }

  // for the uib directive
  function siteClicked(site) {
    $scope.selected = site;
  }

  /**
   * Adds a $watch to that will call the 'onUserConfirmsChangeFn' callback 
   * when $scope.selected is updated,
   * but only if the user confirms they will loose their unsaved modification;
   * if the user cancels then reverts to the previously selected site
   */
  function watchSelectedSite() {
    $scope.$watch("selected", (newSite, oldSite) => {
      if (_revertingToOldSite) {
        _revertingToOldSite = false;
      } else {
        _confirmSiteChangeIfUnsavedChanges()
          .then(() => {
            $scope.selectedId = $scope.selected?.id ?? 0
          },
            () => _revertToOldSiteId($scope, oldSite)
          );
      }
    });
  }

  function _revertToOldSiteId($scope, oldSite) {
    _revertingToOldSite = true;
    $scope.selected = oldSite;
  }

  function _confirmSiteChangeIfUnsavedChanges() {
    return $q(resolve => resolve());
  }

}
